<template>
  <div>
    <h3 class="font-[700] text-[1.125rem] leading-[1.5rem] mb-[12px]">Chapters</h3>
    <div class="chapter overflow-y-scroll max-h-[176px] pb-[20px] pr-[10px] mr-[30px]">
      <div
        v-for="(chapter, index) in videoChapters"
        :key="chapter.title"
        :data-testid="`chapter-container-${index}`"
        class="cursor-pointer"
        @click="click(chapter.title, chapter.timestamp)"
      >
        <div class="flex flex-row justify-between py-[12px] px-[8px]">
          <p class="text-white text-[0.875rem] leading-[1.25rem] mr-[24px]">
            {{ chapter.title }}
          </p>
          <p
            class="font-medium text-center text-[0.875rem] leading-[1.5rem] min-w-[53px] text-[#303036] inline-block px-[11px] bg-[#FEC629] rounded-[8px] h-[fit-content] self-center"
          >
            {{ chapter.timestamp }}
          </p>
        </div>
        <hr class="bg-[#7A7A85] h-[0.5px] border-none" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPreview: {
      type: Boolean,
      default: false,
    },
    videoChapters: {
      type: Array,
      default() {
        return [
          {
            title: 'Chapter 1',
            timestamp: '00:00',
          },
        ];
      },
      validator(chapters) {
        return chapters.every(chapter => chapter.title && chapter.timestamp);
      },
    },
  },
  methods: {
    click(title, timestamp) {
      if (this.isPreview) {
        this.$emit('openRegistrationModal');
      } else {
        this.$emit('jumpToChapter', title, timestamp);
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
